import {
  Analytics,
  logEvent as firebaseLogEvent,
  setCurrentScreen as firebaseSetCurrentScreen,
  getAnalytics,
} from "firebase/analytics"

/**
 * Check if analytics consent has been given via Cookiebot
 */
export function hasAnalyticsConsent(): boolean {
  return typeof Cookiebot !== "undefined" && Cookiebot?.consent?.statistics === true
}

/**
 * Get Firebase Analytics instance only if consent is given.
 * Returns null if no consent - this prevents gtag from loading.
 */
export function getSafeAnalytics(): Analytics | null {
  if (!hasAnalyticsConsent()) {
    return null
  }
  return getAnalytics()
}

/**
 * Log an event only if analytics consent is given.
 * Safely no-ops if no consent.
 */
export function safeLogEvent(eventName: string, eventParams?: Record<string, unknown>): void {
  const analytics = getSafeAnalytics()
  if (analytics) {
    firebaseLogEvent(analytics, eventName, eventParams)
  }
}

/**
 * Set current screen only if analytics consent is given.
 * Safely no-ops if no consent.
 */
export function safeSetCurrentScreen(screenName: string): void {
  const analytics = getSafeAnalytics()
  if (analytics) {
    firebaseSetCurrentScreen(analytics, screenName)
  }
}
